import { render, staticRenderFns } from "./ModalLinkedPositionsArchived.vue?vue&type=template&id=5a2197b0&"
import script from "./ModalLinkedPositionsArchived.vue?vue&type=script&lang=js&"
export * from "./ModalLinkedPositionsArchived.vue?vue&type=script&lang=js&"
import style0 from "./ModalLinkedPositionsArchived.vue?vue&type=style&index=0&id=5a2197b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports